export enum REACT_DEVICE {
  REACT_DEVICE = '1',
  NOT_REACT_DEVICE = '0',
}

export enum RN_HTTP_METHOD {
  DEFAULT_METHOD = 'POST',
  GET = 'GET',
}
